import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { first, Observable } from 'rxjs';
import { PITEventService, UtilsMisc } from '@pit/core';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreFacade } from '@pit/core-store';
import { IDtoResourceType } from '@pit/frontend-model';
import { DtoResourceTypeStoreFactory } from './dto.resource.type.store.factory';
import { IDtoResourceTypeEntityDataService } from '../../module.data/services/interfaces/dto.resource.type.entity.data.service.interface';

@Injectable({
    providedIn: 'root'
})
export class DtoResourceTypeStoreFacade extends EntityStoreFacade<IDtoResourceType> {

    constructor(store: Store<IDtoResourceType>, dataServiceAccessor: EntityDataServiceAccessorService, eventService: PITEventService) {
        super(DtoResourceTypeStoreFactory.instance, store, 'DtoResourceType', dataServiceAccessor, eventService);
    }

    public loadForMandator$(mandator: string): void {
        this.store.dispatch(this.entityStoreFactory.getAction('get.by.mandator')({ mandator: mandator }));
    }

    public async loadForMandatorAsync(mandator: string): Promise<IDtoResourceType[]> {
        let result: IDtoResourceType[] = null;
        try {
            const queryResult: IDtoResourceType[] = await (this.dataServiceAccessor.getEntityDataService<IDtoResourceType>(this.entityStoreFactory.dataAccessName.toLowerCase()) as IDtoResourceTypeEntityDataService).getForMandatorAsync(mandator);
            this.clear();
            if ((UtilsMisc.isNullOrUndefined(queryResult) === false) && (queryResult.length > 0)) {
                result = queryResult;
                this.upsertItemsToStore(result);
            }
        } catch (error) {
        } finally {
        }

        return result;
    }

}
